import axios from 'axios';
import API from '../config/api';
import { resHandle } from '../helper';

export const videoTemplateListService = (params = '') =>
    axios.get(API.VIDEO_TEMPLATE_LIST + params).then((res) => {
        const { status, data } = resHandle(res);
        return { status, data };
    });

export const videoTemplateDetailService = (id) =>
    axios.get(`${API.VIDEO_TEMPLATE_LIST}/${id}`).then((res) => {
        const { status, data } = resHandle(res);
        return { status, data };
    });

export const createVideoTemplateService = (formData) =>
    axios.post(API.VIDEO_TEMPLATE_LIST, formData).then((res) => {
        const { status, data } = resHandle(res);
        return { status, data };
    });

export const updateVideoTemplateService = (id, formData) =>
    axios.put(`${API.VIDEO_TEMPLATE_LIST}/${id}`, formData).then((res) => {
        const { status, data } = resHandle(res);
        return { status, data };
    });

export const deleteVideoTemplateService = (id) =>
    axios.delete(`${API.VIDEO_TEMPLATE_LIST}/${id}`).then((res) => {
        const { status, data } = resHandle(res);
        return { status, data };
    });
